/**
 * Formatea un número de teléfono
 * Reglas (por cantidad de dígitos, ignorando el prefijo "+"):
 *  - 13 dígitos → +54 9 XXX XXX-XXXX  (ej: 5491123456789)
 *  - 12 dígitos → +54 XX XXXX-XXXX    (ej: 541123456789)
 *  - 11 dígitos → 0XX XXXX-XXXX       (ej: 01123456789)
 *  - 10 dígitos → XXX XXX-XXXX        (ej: 1123456789)
 *  - cualquier otro largo → se devuelve tal cual
 *
 * @param {string} raw  Valor crudo (solo dígitos, puede tener "+" al inicio)
 * @returns {string}
 */
export function formatPhoneNumber(raw) {
    if (!raw) return "";
  
    // Conservar si empieza con "+" para detectar internacionales
    const hasPlus = raw.startsWith("+");
    const digits = raw.replace(/\D/g, "");
  
    switch (digits.length) {
      case 13:
        return `+${digits.slice(0, 2)} ${digits[2]} ${digits.slice(3, 6)} ${digits.slice(6, 9)}-${digits.slice(9)}`;
      case 12:
        return `+${digits.slice(0, 2)} ${digits.slice(2, 4)} ${digits.slice(4, 8)}-${digits.slice(8)}`;
      case 11: 
        return `0${digits.slice(1, 3)} ${digits.slice(3, 7)}-${digits.slice(7)}`;
      case 10: 
        return `${digits.slice(0, 3)} ${digits.slice(3, 6)}-${digits.slice(6)}`;
      default:
        return hasPlus ? `+${digits}` : digits || raw;
    }
  }
  
  /**
   * Filtra un evento de teclado para permitir solo dígitos (y teclas de control).
   * Úsalo en el prop `onKeyDown` del TextField.
   *
   * @param {React.KeyboardEvent} e
   */
  export function onlyDigitsKeyDown(e) {
    const allowed = [
      "Backspace", "Delete", "Tab", "Escape", "Enter",
      "ArrowLeft", "ArrowRight", "ArrowUp", "ArrowDown",
      "Home", "End",
    ];
    if (allowed.includes(e.key)) return;
    if (e.ctrlKey || e.metaKey) return; // Ctrl+C, Ctrl+V, etc.
    if (!/^\d$/.test(e.key)) e.preventDefault();
  }